import $ from 'jquery';
/*
var option={
	'box':$(this).find('[rel="box"]').get(0),
	'width':width,
	'show':show,
	'direction':'vertical',//'horizonal'
	'navBox':{
		'left':$(this).parent().find('.prev a').get(0),
		'right':$(this).parent().find('.next a').get(0),
	},
};
*/
var Nav=function(option)
{
	this.option=this.getOption(option);
	
	//容器元素
	this.box=this.option.box;
	
	if(this.option.direction == 'vertical')
	{
		//容器子元素宽度
		this.width=this.option.width;
		//容器高度
		this.height=$(this.box).height();
	}
	else
	{
		//容器子元素高度
		this.height=$(this.box).height();
		//容器宽度
		this.width=this.option.width;
	}
	
	this.show=this.option.show;
	this.count=$(this.box).children(':not(.clear)').length;
	this.current=0;
	
	this.init();
};
Nav.prototype.init=function()
{
	if(this.option.direction == 'vertical')
	{
		//初始化容器宽度
		var fullWidth=this.width * this.count;
		$(this.box).css({
			'width':fullWidth,
			'position':'relative',
		});
	}
	else 
	{
		//初始化容器高度
		var fullHeight=this.height * this.count;
		$(this.box).css({
			'height':fullWidth,
			'position':'relative',
		});
	}

	var _this=this;
	$(this.option.navBox.left).addClass('disabled').on('click',function()
	{
		_this.go(-1);
	});
	$(this.option.navBox.right).on('click',function()
	{
		_this.go(1);
	});
};

Nav.prototype.go=function(step)
{
	var next=step+this.current;
	//if(next<0 || next>this.count-this.show-1)
	if(next<0 || next>this.count-this.show)
		return false;
	
	var duration=this.option.duration;
	if(this.option.direction == 'vertical')
	{
		var a=-next*this.width;
		$(this.box).animate({'left':a+'px'},duration,_next);
	}
	else
	{
		var a=-next*this.height;
		$(this.box).animate({'top':a+'px'},duration,_next);
	}
	
	var _this=this;
	function _next()
	{
		if(next == 0)
			$(_this.option.navBox.left).addClass('disabled');
		else
			$(_this.option.navBox.left).removeClass('disabled');
		
		if(next+_this.show == _this.count)
			$(_this.option.navBox.right).addClass('disabled');
		else
			$(_this.option.navBox.right).removeClass('disabled');
		
		_this.current=next;
		
	}
};
Nav.prototype.getOption=function(option)
{
	if(!option['duration'])
		option.duration=500;
	if(!option.direction)
		option.direction = 'vertical';
	
	return option;
};
export default Nav;
